import React from 'react'


const MarkerIcon = (props) => {
    return(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.active ? "45": "40"}
      height={props.active ? "45": "40"}
      fill="none"
      viewBox="0 0 40 40"
    >
      <g filter="url(#filter0_d)">
        <circle cx="20" cy="18" r="12" fill={props.active ? "#00114A" : "#fff"}></circle>
      </g>
      <circle cx="20" cy="18" r="5" fill={props.active ? "#fff" :"#00114A"}></circle>
      <defs>
        <filter
          id="filter0_d"
          width="40"
          height="40"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feMorphology
            in="SourceAlpha"
            radius="4"
            result="effect1_dropShadow"
          ></feMorphology>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="6"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.0666667 0 0 0 0 0.290196 0 0 0 0.7 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
    )
    }


export {
    MarkerIcon
}


